<template>
  <v-container grid-list-md fluid>
    <v-layout row>
      <v-flex md12>
        <v-card>
          <v-toolbar dense primary-title>
            <v-toolbar-title>{{$t('view.plantillaCorreo.form.label')}}</v-toolbar-title>  
            <v-spacer></v-spacer>
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>                
          </v-toolbar>
          <v-slide-y-transition>
            <div v-show="view.elem.showForm">
              <v-card-text>
                <v-form role="form">
                  <v-layout row  v-if="view.action.submit.busy">
                    <vue-content-loading :width="450" :height="158">
                      <rect x="0" y="0" rx="4" ry="4" width="53" height="10" />
                      <rect x="0" y="15" rx="4" ry="4" width="442" height="34" />
                      <rect x="0" y="64" rx="4" ry="4" width="53" height="10" />
                      <rect x="0" y="79" rx="4" ry="4" width="442" height="34" />
                      <rect x="0" y="128" rx="10" ry="10" width="80" height="30" />
                    </vue-content-loading>
                  </v-layout>
                      
                  <v-layout row >
                    <v-flex md6 v-show="view.elem.input.clave.visible" v-if="!view.action.submit.busy" >
                      <v-text-field 
                        v-model="$v.plantillaCorreo.clave.$model"
                        :disabled="view.elem.input.clave.disabled"
                        :error-messages="getFirstErrorDescription($v.plantillaCorreo.clave)"
                        :label="$t('view.plantillaCorreo.clave.placeholder')" ></v-text-field>
                    </v-flex >
                    <v-flex md6 v-if="!view.action.submit.busy" >
                      <v-text-field 
                        v-model="$v.plantillaCorreo.descripcion.$model"
                        :error-messages="getFirstErrorDescription($v.plantillaCorreo.descripcion)"
                        :label="$t('view.plantillaCorreo.descripcion.label')" >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row >
                    <v-flex md6 v-if="!view.action.submit.busy">
                      <v-text-field 
                        v-model="$v.plantillaCorreo.destinatariosOpcionales.$model"
                        :error-messages="getFirstErrorDescription($v.plantillaCorreo.destinatariosOpcionales)"
                        :label="$t('view.plantillaCorreo.destinatariosOpcionales.label')" >
                      </v-text-field>
                    </v-flex>
                    <v-flex md6 v-if="!view.action.submit.busy" >
                      <v-combobox
                        v-model="$v.plantillaCorreo.multiListPerfilesDestinatarios.$model" 
                        :items="view.elem.select.groups.options"
                        :label="$t('view.plantillaCorreo.multiListPerfilesDestinatarios.label')"
                        :error-messages="getFirstErrorDescription($v.plantillaCorreo.multiListPerfilesDestinatarios)"
                        chips
                        small-chips
                        color="blue-grey lighten-2"
                        item-text="name"
                        item-value="code"
                        :max-height="200" 
                        dense
                        multiple
                        clearable
                        deletable-chips
                        :no-data-text= "$t('view.global.common.no-data-text')" >
                      </v-combobox>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6 v-if="!view.action.submit.busy" >
                        <v-text-field 
                          v-model="$v.plantillaCorreo.asunto.$model"
                          :error-messages="getFirstErrorDescription($v.plantillaCorreo.asunto)"
                          :label="$t('view.plantillaCorreo.asunto.label')" >
                        </v-text-field>
                    </v-flex>
                    <v-flex md6 v-if="!view.action.submit.busy" >
                        <v-text-field 
                          v-model="$v.plantillaCorreo.remitente.$model"
                          :error-messages="getFirstErrorDescription($v.plantillaCorreo.remitente)"
                          :label="$t('view.plantillaCorreo.remitente.label')" >
                        </v-text-field>
                      
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md6 v-if="!view.action.submit.busy" >
                        <v-text-field 
                          v-model="$v.plantillaCorreo.cc.$model"
                          :error-messages="getFirstErrorDescription($v.plantillaCorreo.cc)"
                          :label="$t('view.plantillaCorreo.cc.label')" >
                        </v-text-field>
                    </v-flex>
                    <v-flex md6 v-if="!view.action.submit.busy" >
                        <v-text-field 
                          v-model="$v.plantillaCorreo.cco.$model"
                          :error-messages="getFirstErrorDescription($v.plantillaCorreo.cco)"
                          :label="$t('view.plantillaCorreo.cco.label')" >
                        </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md12 v-if="!view.action.submit.busy" 
                      v-bind:class="[hasErrors($v.plantillaCorreo.cuerpo)?'has-error':'']">
                      <label>{{$t('view.plantillaCorreo.cuerpo.label')}}</label>
                      <vue-editor 
                        :editorOptions="editorSettings"
                        v-model="plantillaCorreo.cuerpo">
                      </vue-editor>
                      <label class="error--text" for="cuerpo" v-if="$v.plantillaCorreo.cuerpo.$dirty">
                        {{$t(`validator.${getFirstError($v.plantillaCorreo.cuerpo)}.text`,"")}} 
                      </label>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex md12 v-if="!view.action.submit.busy" >
                      <label>{{$t('view.plantillaCorreo.status.label')}}</label>
                      <v-switch v-if="!view.action.submit.busy" 
                      input-value="true" color="primary" 
                      :sync="true" 
                      :label="$v.plantillaCorreo.status.$model ? 'on' : 'off'" 
                      v-model="$v.plantillaCorreo.status.$model" >
                      </v-switch>
                    </v-flex>
                  </v-layout >
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-flex shrink >
                  <v-tooltip v-show="view.elem.button.audit.visible && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')" top>
                    <v-btn 
                      @click="showAudit()" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>storage</v-icon>
                    </v-btn>
                    <span>{{$t('view.global.common.auditoria')}}</span>
                  </v-tooltip>
                  <v-tooltip v-if="view.elem.button.clear.visible" top>
                    <v-btn 
                      @click="clear()" 
                      :loading="view.action.submit.busy" 
                      icon slot="activator" color="primary" large>
                      <v-icon>clear</v-icon>
                    </v-btn>
                    <span>{{$t('view.global.common.cancel')}}</span>
                  </v-tooltip>
                  <v-tooltip  v-show="$userPermission.hasPermission('ROLE_MODIFICAR_CATALOGOS')" top>
                    <v-btn 
                      :disabled="state.isDisableButtonSubmit()"
                      :loading="view.action.submit.busy" 
                      @click="submit()" 
                      color="primary"
                      icon slot="activator"  large>
                      <v-icon>check</v-icon>
                    </v-btn>
                    <span>{{submitTitle}}</span>
                  </v-tooltip>
                </v-flex>
              </v-card-actions>
            </div>
          </v-slide-y-transition>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row >
      <v-flex md12>
        <data-table ref="tablePlantillaCorreo" @editRow="loadPlantillaCorreo" @auditRow="showAudit"></data-table>
      </v-flex>
    </v-layout>
    <auditoria ref="auditModal"></auditoria>
  </v-container>
</template>
<script>
import {PlantillaCorreoModel} from "@/models/generales/plantilla-correo";
import PlantillaCorreoAPI from "@/services/generales/plantillaCorreo";
import CombosAPI from "@/services/catalogos";
import {required,email, maxLength} from "vuelidate/lib/validators";
import {emailList} from "@/helpers/vuelidate/validators";
import {allValidatorMethods} from "@/helpers/vuelidate";
import VueContentLoading from 'vue-content-loading';
import DataTable from "@/views/generales/plantillaCorreo/DataTable";
import Auditoria from "@/components/auditoria/Auditoria";
import Multiselect from 'vue-multiselect';
import bTooltip from 'bootstrap-vue/es/components/tooltip/tooltip';
import bTooltipDirective from 'bootstrap-vue/es/directives/tooltip/tooltip';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import * as states from '@/views/generales/plantillaCorreo/plantilla-correo-states';
import * as R from "ramda";
import tippy from 'tippy.js';
import {VueEditor, Quill} from "vue2-editor";
import { ImageDrop } from 'quill-image-drop-module';
import ImageResize from 'quill-image-resize-module';
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);
import {getErrors,getBusinessCode,getResponseDTO} from '@/helpers/http-response-handler';
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';
import {scrollToForm} from '@/helpers/form-scroll-to';
import {IndentStyle} from '@/helpers/quill-extensions';

//Element's Settings
const button = {
  submit:{
    enable:true
    , text:""
    , class:{
      current:""
      , save:"button__icon icon fa fa-plus"
      , update:"button__icon icon fa fa-check"
    }, data:{
       title:{
        current:"",
        save:"Guardar",
        update:"Actualizar"
       }
    }
  }
  , clear:{
    visible:false
  }
  , audit:{
    visible:false
  }
};

const input = {
  clave :{
    disabled:true
    , visible: false
  }
}
//Action's state
const action = {
  submit:{
    busy:false
  }
};
let select = {
  groups:{
    options:[{name:'ADMINISTRADOR', code:'1'}]
  }
}
const wysiwyg={
  emailContent:{
    editorOption:{
      modules: {
        toolbar: [
          [{ 'size': ['small', false, 'large'] }],
          ['bold', 'italic'],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ['link', 'image']
        ],
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false
        },
        imageDrop: true
        , imageResize: {
          displayStyles: {
            backgroundColor: 'black',
            border: 'none',
            color: 'white'
          }
          , modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
        }
      }
    }
  }
}

export default {
  name: "PlantillaCorreo",
  head:{
    title:function(){
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      }
    }
  }
  , data() {
    return {
      locale: this.$store.language
      , editorSettings:{
        modules: {
          imageDrop: true,
          imageResize: {},
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }]
            , ['bold', 'italic', 'underline', 'strike']
            , [{ 'align': ''},{'align':'center'},{'align':'right'},{'align':'justify'}]
            , [{ 'list': 'ordered' }, { 'list': 'bullet' }] //, {'list':'check'}
            , [{ 'indent': '+1' }, { 'indent': '-1' }]
            , [{ 'color': [] }, { 'background': [] }]
            , ['link', 'image']
            , ['clean']
          ]
        }
      }
      , plantillaCorreo : undefined
      , state : new Object()
      , view:{
        title:"Plantillas Correo"
        , action
        , elem:{
          button
          , select
          , wysiwyg
          , input
          , showForm: true
        }
      }
    };
  }
  ,methods: {
    ...allValidatorMethods
    , getErrorsPlantillaCorreo(defaultMessage, message, code){
      return getErrors('PlantillaCorreo',defaultMessage, message, code);
    }
    , getBusinessCodePlantillaCorreo(response){
      return getBusinessCode(response);
    }
    , getResponseDTOPlantillaCorreo(response){
      return getResponseDTO(response);
    }
    , handleResponse(response){
      const code = this.getBusinessCodePlantillaCorreo(response);
      if(code == 'OK')
      {
        EventBus.$emit(events.MESSAGES, {type:code});
        return true;
      }
      else 
      {
        if(response != false)
          EventBus.$emit(events.MESSAGES, {type:'error',message: this.getErrorsPlantillaCorreo('Mensaje Default',code)});
        return false;
      }
    }
    , async submit(){
      try{
        const respuesta = await this.state.submit(this.plantillaCorreo);
        const responseDTO = this.getResponseDTOPlantillaCorreo(respuesta);
        this.handleResponse(respuesta);
        Object.setPrototypeOf(this.state, new states.EditingState(this, responseDTO.plantillaCorreo));    
      }catch(error){
      }
    }
    , async loadPlantillaCorreo(idPlantillaCorreo){
      try{
        const response = await PlantillaCorreoAPI.get({clave:idPlantillaCorreo});      
        const {data:{results:{plantillaCorreo}}} = response;
        Object.setPrototypeOf(this.state, new states.EditingState(this,plantillaCorreo));
        scrollToForm(this);
      }catch(error){
        console.log(error)
      }
    }
    , clear(){
       this.state.clear();
    }
    , async showAudit(id=this.plantillaCorreo.clave,dataDescripcion=this.plantillaCorreo.descripcion){
        this.$refs.auditModal.loadAudit({clave:id,tabla:'TPlantillaCorreo',descripcion:dataDescripcion,revision:null});
    }
    , addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag)
    }
    , getLimitText(){
      return count=> ` y  ${count} más `;
    }
  }
  , computed:{
    submitClass(){
      return this.view.elem.button.submit.class.current
    },
    submitTitle(){

      return this.view.elem.button.submit.data.title.current
    }
  }
  , validations:{
    plantillaCorreo:{
      clave:{
        required
        , maxLength : maxLength(20)
      }
      , remitente:{
        required
        , email
        , maxLength : maxLength(255)
      }
      , descripcion:{
        required
        , maxLength : maxLength(255)
      }
      , multiListPerfilesDestinatarios:{
        required:false
        , maxLength : maxLength(1000)
      }
      , destinatariosOpcionales:{
        emailList:emailList(';')
        , maxLength : maxLength(1000)
      }
      , cc:{
        emailList:emailList(';')
        , maxLength : maxLength(1000)
      }
      , cco:{
        emailList:emailList(';')
        , maxLength : maxLength(1000)
      }
      , asunto:{
        required
        , maxLength : maxLength(255)
      }
      , cuerpo:{
        required
      }
      , status:{
        required
      }
    }
  }
  , components: {
    VueContentLoading
    , DataTable
    , Auditoria
    , Multiselect
    , 'b-tooltip': bTooltip
    , VueEditor
  }
  , directives:{
    'b-tooltip': bTooltipDirective
  }
  // Instance Lifecycle Hooks
  , async created(){
    Object.setPrototypeOf(this.state, new states.InitialState(this));
    const responseCombos = await CombosAPI.get({tipo:'grupos'});
    select.groups.options = responseCombos.data.results.combo;
    // Configures quill plugin
    const AlignStyle  = Quill.import('attributors/style/align');
    Quill.register(AlignStyle, true);
    Quill.register(IndentStyle, true);
  }
  , mounted(){
    // this.$parent.appJQueryConfigMethod();
  },
  updated(){
    this.$nextTick(function(){
      tippy('.btn', {
            arrow: true,
            arrowType: 'round',
            size: 'large',
            animation: 'scale'
          });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.quill-editor{
  height:300px;
  padding-bottom: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/views/generales/plantillaCorreo/PlantillaCorreo.vue